/**
 * Custom hook for header scroll behavior
 * Extracted from Header.js
 */

import { useState, useEffect } from 'react';

/**
 * Custom hook to handle header scroll state
 * @param {boolean} isHomepage - Whether current page is homepage
 * @returns {boolean} Whether header is scrolled
 */
export function useHeaderScroll(isHomepage) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // On homepage, header is always visible, so always set scrolled
      if (isHomepage) {
        setIsScrolled(true);
      } else {
        const scrolled = window.scrollY > 50;
        setIsScrolled(scrolled);
      }
    };
    
    // Check initial scroll position
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomepage]);

  return isScrolled;
}
